var jimdoData = require('jimdoData');
var $;

function shouldLoadJQueryCms() {
    if (jimdoData && jimdoData.isCMS) {
        try {
            require('jquery-cms');
            return true;
        } catch (e) {
            return false;
        }
    }

    return false;
}

if (shouldLoadJQueryCms()) {
    $ = require('jquery-cms');
} else {
    $ = require('jquery-web');
}

$.migrateMute = true;
module.exports = $;
require('jquery-migrate');



//////////////////
// WEBPACK FOOTER
// ./webserver/document_root/s/js/proxy-jquery.js
// module id = 1
// module chunks = 174 178 179 184 185 186 189 190 193 194 196 197